import actions from './actions';
import initialState from '../initialState';

export const hmdaReducer = (state = initialState.hmda, action) => {
    switch (action.type) {
        case actions.HMDA_EDIT_MODAL:
            return { ...state, hmdaEditModal: action.state.hmdaEditModal };
        case actions.HMDA_EXPORT_MODAL:
            return { ...state, hmdaExportModal: action.state.hmdaExportModal };
        case actions.HMDA_MANAGE_DELETED_MODAL:
            return {
                ...state,
                hmdaManageDeletedModal: action.state.hmdaManageDeletedModal,
            };
        default:
            return { ...state };
    }
};

export default hmdaReducer;
